<script setup lang="ts">
  withDefaults(
    defineProps<{
      fullWidth?: boolean,
    }>(),
    {
      fullWidth: true,
    },
  )
</script>

<template>
  <div class="max-xl:overflow-x-auto max-xl:overflow-y-hidden">
    <table
      class="app-table"
      :class="{ 'w-full': fullWidth }">
      <slot></slot>
    </table>
  </div>
</template>

<style lang="postcss" scoped>
  :deep() {
    .app-table {
      @apply max-md:text-sm;

      thead {
        @apply z-1 top-12 bg-app xl:sticky;
        /* border-b not working, need to use box-shadow */
        @apply shadow-[inset_0_-1px_0_rgba(0,0,0,1)] shadow-gray-200;
      }

      th {
        @apply py-3 align-bottom font-bold;
      }

      th,
      td {
        @apply px-1 md:px-2;
      }
      /* workaround for customer page list has nested td with display contents */
      tr {
        & > th,
        & > td {
          @apply first:pl-0 last:pr-0 md:px-2;
        }
      }

      td {
        @apply border-b py-2;

        .clickable {
          @apply decoration-blue text-left underline decoration-dotted decoration-1 underline-offset-4;
        }

        &.buttons {
          @apply text-right space-x-1 whitespace-nowrap py-1;
          .btn-icon {
            @apply btn-low-priority inline-block text-gray-500;
          }
        }

        strong {
          @apply font-semibold;
        }
      }

      /* workaround for customer page list has nested td with display contents */
      & > tbody > tr:last-of-type > td {
        @apply border-b-0;
      }
    }
  }
</style>
